import { render, staticRenderFns } from "./delete_icon.vue?vue&type=template&id=58374fe9&functional=true"
import script from "./delete_icon.vue?vue&type=script&lang=js"
export * from "./delete_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports